(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/hooks/use-closetime-ticker.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/hooks/use-closetime-ticker.js');

'use strict';

const {
  useEffect,
  useState
} = React;
const {
  intervalToDuration,
  isAfter
} = dateFns;
const weekDraws = svs.numbergames.draws.getWeekDraws();
const useCloseTimeTicker = endTime => {
  const [countdown, setCountDown] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const end = new Date(endTime);
    const interval = setInterval(() => {
      const start = weekDraws.clientNow;
      if (isAfter(start, end)) {
        setCountDown({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }
      const {
        hours,
        minutes,
        seconds
      } = intervalToDuration({
        start,
        end
      });
      setCountDown({
        hours,
        minutes,
        seconds
      });
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [endTime]);
  return countdown;
};
svs.gamePackage.hooks.useCloseTimeTicker = useCloseTimeTicker;

 })(window);